export const MAX_DIMENSIONS_ALLOWED = 3;

export const MESSAGES = {
  MAX_DIMENSIONS_WARNING: 'You can select up to 3 dimensions at a time',
  EXPORT_PREPARING: 'Preparing export...',
  EXPORT_SUCCESS: 'Export completed successfully!',
  EXPORT_FAILED: 'Export failed',
  VALIDATION_ERROR: 'Please fill in all required fields',
  SELECT_DIMENSION: 'Please select at least one dimension',
  SELECT_METRIC: 'Please select at least one metric',
  SELECT_BENCHMARK_TYPE: 'Please select a benchmark type',
};

export const BENCHMARK_TYPES = {
  GOOD: 'good' as const,
  BEST: 'best' as const,
};

export const PERCENTILE_TYPES = {
  P50: 50,
  P95: 95,
};
